import React from 'react'
import { ContentDetach } from '@fs/zion-icon'
import { ListItem } from '@fs/zion-ui'
import {
  useSlsStateContext,
  getNestedOrFloatingElementById,
  getPersonName,
  getRelationshipToPrimaryPersonDisplayLabel,
  getRelationshipToPrimaryPersonText,
  getPrimaryRelationshipText,
} from '@fs/zion-sls'
import { useTranslation } from 'react-i18next'

const LinkedNameItem = ({ element, selectHandler }) => {
  const [t] = useTranslation()
  const slsState = useSlsStateContext()
  const record = getNestedOrFloatingElementById(slsState.images, element.recordId)
  const primaryRelationshipLabel = `${getRelationshipToPrimaryPersonDisplayLabel(element, slsState.types, record)}`
  const relationshipText = `${getRelationshipToPrimaryPersonText(element, slsState.types, record, t)}`
  const primaryRelationshipText = getPrimaryRelationshipText(primaryRelationshipLabel, relationshipText)
  return (
    <ListItem
      key={element.id}
      data-testid={`linked-name-${element.id}`}
      primaryText={getPersonName({ person: element })}
      overline={primaryRelationshipText}
      onClick={() => selectHandler(element)}
      endElement={<ListItem.Icon Icon={ContentDetach} />}
    />
  )
}
export default LinkedNameItem
